import React from 'react';
import { Route } from 'react-router';
import { translate } from 'react-i18next';
import VehicleDetailsInspectionContent from './VehicleDetailsInspectionContent';
import VehicleDetailsInspectionList from './VehicleDetailsInspectionList';
import VehicleDetailsSectionHeader from './VehicleDetailsSectionHeader';
import CBMediaQuery from '../../shared/CBMediaQuery';

class VehicleDetailsNavbar extends React.Component {
  render() {
    const { t, vehicle } = this.props;
    return (
      <CBMediaQuery>
        {screenSize => (
          <div>
            <VehicleDetailsSectionHeader type='inspection' text={t('inspectionsHeading')} />
            {screenSize === 'small' && <VehicleDetailsInspectionList vehicle={vehicle} />}
            <div style={styles.mainContentContainer}>
              {screenSize !== 'small' && <VehicleDetailsInspectionList vehicle={vehicle} />}
              <Route
                exact
                path='/vehicle/:vehicleId/inspections/'
                render={() => <VehicleDetailsInspectionContent vehicle={vehicle} />}
              />
              <Route
                path='/vehicle/:vehicleId/inspections/:inspectionId'
                render={props => <VehicleDetailsInspectionContent {...props} vehicle={vehicle} />}
              />
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  mainContentContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
};

export default translate('VehicleDetailsView')(VehicleDetailsNavbar);
